import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=6d53bea4&"
import script from "./js/purchase-list.js?vue&type=script&lang=js&"
export * from "./js/purchase-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports